<template>
  <ModalSelectOption
    :show="show"
    @update:show="emit('update:show', $event)"
    :options="[
      {
        text: '全部 OC',
        value: undefined,
      },
      ...mateStore.list.map((mate) => ({
        text: mate.name,
        value: mate.id,
      })),
    ]"
    :initial-value="activeMateId"
    @confirm="onConfirmOc"
  />
</template>

<script setup lang="ts">
import { useMate } from "@/stores/mate";

defineProps<{
  activeMateId?: number;
  show: boolean;
}>();

const mateStore = useMate();

const emit = defineEmits<{
  (event: "update:show", value: boolean): void;
  (event: "confirm", value: number): void;
}>();

const onConfirmOc = (value: number) => {
  emit("update:show", false);
  emit("confirm", value);
};
</script>
